import Image from 'molecules/Image';

import LottiePlayer from 'components/LottiePlayer/LottiePlayer';

type ImageData = {
  url: string;
  alt?: string;
  file: {
    url: string;
    width?: number;
    height?: number;
  };
};

type LottieData = {
  url: string;
  loop?: boolean;
  autoplay?: boolean;
  type?: 'json' | 'lottie';
};

type Props = {
  desktopImage?: ImageData;
  mobileImage?: ImageData;
  desktopLottie?: LottieData;
  mobileLottie?: LottieData;
  className?: string;
};

const HeroImages = ({ desktopImage, mobileImage, desktopLottie, mobileLottie, className }: Props) => {
  if (desktopLottie) {
    return (
      <div className={className}>
        {mobileLottie && (
          <LottiePlayer
            src={mobileLottie.url}
            loop={mobileLottie.loop}
            autoplay={mobileLottie.autoplay}
            type={mobileLottie.type || 'json'}
            className="block size-full sm:hidden"
          />
        )}

        <LottiePlayer
          src={desktopLottie.url}
          loop={desktopLottie.loop}
          autoplay={desktopLottie.autoplay}
          type={desktopLottie.type || 'json'}
          className={`size-full ${mobileLottie ? 'hidden sm:block' : 'block'}`}
        />
      </div>
    );
  }

  if (!desktopImage) {
    return null;
  }

  return (
    <div className={className}>
      {mobileImage && (
        <Image
          alt={mobileImage.alt || desktopImage.alt || ''}
          className="block size-full sm:hidden"
          {...mobileImage.file}
          priority={true}
        />
      )}

      <Image
        alt={desktopImage.alt || mobileImage?.alt || ''}
        className={`size-full ${mobileImage ? 'hidden sm:block' : 'block'}`}
        {...desktopImage.file}
        priority={true}
      />
    </div>
  );
};

export default HeroImages;
